module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon9.c5126813.svg";